// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app{overflow-y:scroll;overflow-x:hidden}", "",{"version":3,"sources":["webpack://./app/javascript/packs/vue/screens/users/search.vue"],"names":[],"mappings":"AACA,KACE,iBAAA,CACA,iBAAA","sourcesContent":["\n.app {\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
